module.exports = __webpack_public_path__ + "static/picasso-body-nocover-glasses-gradient-c528013dd8bd4c0657d7aa4c35e0f888.webp";